import configDefault, { IConfig } from './ConfigDefault';

/**
 * 生产配置
 */
const configData: IConfig = {
	...configDefault,
	/**
	 * 显示日志
	 *
	 * @type {boolean}
	 * @memberof ConfigDefault
	 */
	isDisplayLogs: true,

	/** 代理配置 */
	proxyTable: {
		'/umaterial': {
			target: 'http://127.0.0.1:8090',
			changeOrigin: true,
			pathRewrite: {
				'^/umaterial': '/'
			}
		},
		'/ubuy': {
			target: 'http://127.0.0.1:8080',
			changeOrigin: true,
			pathRewrite: {
				'^/ubuy': '/'
			}
		},
		'/pages': {
			target: 'http://127.0.0.1:8080',
			changeOrigin: true
		},
		'/logout': {
			target: 'http://127.0.0.1:8080',
			changeOrigin: true
		},
		'/login': {
			target: 'http://127.0.0.1:8080',
			changeOrigin: true
		},
		'/order': {
			target: 'http://127.0.0.1:8080',
			changeOrigin: true
		},
		'/material': {
			target: 'http://127.0.0.1:8080',
			changeOrigin: true
		}
	}
};

export default configData;
